// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DateSeparator-module__font-s-10___jWAo3 {
  font-size: 10px !important;
}

.DateSeparator-module__font-s-12___lCdrE {
  font-size: 12px !important;
}

.DateSeparator-module__font-s-13___MuLNn {
  font-size: 13px !important;
}

.DateSeparator-module__font-s-14___dr2dM {
  font-size: 14px !important;
}

.DateSeparator-module__font-s-15___O8Sm4 {
  font-size: 15px !important;
}

.DateSeparator-module__font-s-16___RU1wm {
  font-size: 16px !important;
}

.DateSeparator-module__font-s-18___epV4k {
  font-size: 18px !important;
}

.DateSeparator-module__font-s-20___fWkqF {
  font-size: 20px !important;
}

.DateSeparator-module__font-s-22___bKHWX {
  font-size: 22px !important;
}

.DateSeparator-module__font-s-28___ykbmv {
  font-size: 28px !important;
}

.DateSeparator-module__font-w-400___hFXGw {
  font-weight: 400 !important;
}

.DateSeparator-module__font-w-500___MfeYF {
  font-weight: 500 !important;
}

.DateSeparator-module__font-w-600___Tf2Xu {
  font-weight: 600 !important;
}

.DateSeparator-module__font-w-700___dW177 {
  font-weight: 700 !important;
}

.DateSeparator-module__p-5___FyScb {
  padding: 5px !important;
}

.DateSeparator-module__p-12___OffKn {
  padding: 12px !important;
}

.DateSeparator-module__p-16___scc8V {
  padding: 16px !important;
}

.DateSeparator-module__p-30___OXu_e {
  padding: 30px !important;
}

.DateSeparator-module__p-b-0___C7Nte {
  padding-bottom: 0 !important;
}

.DateSeparator-module__p-b-5___uyiyp {
  padding-bottom: 5px !important;
}

.DateSeparator-module__p-b-10___N8gBA {
  padding-bottom: 10px !important;
}

.DateSeparator-module__p-b-12___by46z {
  padding-bottom: 12px !important;
}

.DateSeparator-module__p-b-16___aUem7 {
  padding-bottom: 16px !important;
}

.DateSeparator-module__p-b-18___GAyCG {
  padding-bottom: 18px !important;
}

.DateSeparator-module__p-b-20___mWwHW {
  padding-bottom: 20px !important;
}

.DateSeparator-module__p-b-25___cALw4 {
  padding-bottom: 25px !important;
}

.DateSeparator-module__p-b-30___oFHtp {
  padding-bottom: 30px !important;
}

.DateSeparator-module__p-b-50___AQpI7 {
  padding-bottom: 50px !important;
}

.DateSeparator-module__p-t-0___Mpjzg {
  padding-top: 0 !important;
}

.DateSeparator-module__p-t-12___P8OPG {
  padding-top: 12px !important;
}

.DateSeparator-module__p-t-16___cjhlo {
  padding-top: 16px !important;
}

.DateSeparator-module__p-t-18___zKaih {
  padding-top: 18px !important;
}

.DateSeparator-module__p-t-20___TqUTl {
  padding-top: 20px !important;
}

.DateSeparator-module__p-t-30___CLLif {
  padding-top: 30px !important;
}

.DateSeparator-module__p-t-40___W5oTO {
  padding-top: 40px !important;
}

.DateSeparator-module__p-t-50___YiB0Z {
  padding-top: 50px !important;
}

.DateSeparator-module__p-l-20___TRk5g {
  padding-left: 20px !important;
}

.DateSeparator-module__p-l-30___RBcHb {
  padding-left: 30px !important;
}

.DateSeparator-module__p-l-40___V4APa {
  padding-left: 40px !important;
}

.DateSeparator-module__p-r-16___eV432 {
  padding-right: 16px !important;
}

.DateSeparator-module__p-r-20___kPvGz {
  padding-right: 20px !important;
}

.DateSeparator-module__p-r-30___bpEav {
  padding-right: 30px !important;
}

.DateSeparator-module__p-r-50___ypuCP {
  padding-right: 50px !important;
}

.DateSeparator-module__p-r-60___PgBHd {
  padding-right: 60px !important;
}

.DateSeparator-module__m-b-1___YtedF {
  margin-bottom: 1px !important;
}

.DateSeparator-module__m-b-2___sB4A_ {
  margin-bottom: 2px !important;
}

.DateSeparator-module__m-b-6___tlDQQ {
  margin-bottom: 6px !important;
}

.DateSeparator-module__m-b-8___qfDkT {
  margin-bottom: 8px !important;
}

.DateSeparator-module__m-b-10___ahbc3 {
  margin-bottom: 10px !important;
}

.DateSeparator-module__m-b-14___IN8np {
  margin-bottom: 14px !important;
}

.DateSeparator-module__m-b-16___VsS59 {
  margin-bottom: 16px !important;
}

.DateSeparator-module__m-b-20___pjBW1 {
  margin-bottom: 20px !important;
}

.DateSeparator-module__m-b-22___WpMtr {
  margin-bottom: 22px !important;
}

.DateSeparator-module__m-b-24___C4fPV {
  margin-bottom: 24px !important;
}

.DateSeparator-module__m-b-30___W0ynW {
  margin-bottom: 30px !important;
}

.DateSeparator-module__m-b-32___bGOzj {
  margin-bottom: 32px !important;
}

.DateSeparator-module__m-b-40___Y7UDe {
  margin-bottom: 40px !important;
}

.DateSeparator-module__m-t-2___CbfGq {
  margin-top: 2px !important;
}

.DateSeparator-module__m-t-3___NYQ5Q {
  margin-top: 3px !important;
}

.DateSeparator-module__m-t-4___thxhY {
  margin-top: 4px !important;
}

.DateSeparator-module__m-t-5___Y82ye {
  margin-top: 5px !important;
}

.DateSeparator-module__m-t-8___mWEyQ {
  margin-top: 8px !important;
}

.DateSeparator-module__m-t-10___cJHgv {
  margin-top: 10px !important;
}

.DateSeparator-module__m-t-15___EH5u2 {
  margin-top: 15px !important;
}

.DateSeparator-module__m-t-16___lwMzS {
  margin-top: 16px !important;
}

.DateSeparator-module__m-t-20___IytLk {
  margin-top: 20px !important;
}

.DateSeparator-module__m-t-22___CIuOP {
  margin-top: 22px !important;
}

.DateSeparator-module__m-t-30___zilZY {
  margin-top: 30px !important;
}

.DateSeparator-module__m-t-32___e18aR {
  margin-top: 32px !important;
}

.DateSeparator-module__m-l-auto___dQ1wc {
  margin-left: auto !important;
}

.DateSeparator-module__m-l-4___OcKPy {
  margin-left: 4px !important;
}

.DateSeparator-module__m-l-5___GGj7E {
  margin-left: 5px !important;
}

.DateSeparator-module__m-l-6___SpYzq {
  margin-left: 6px !important;
}

.DateSeparator-module__m-l-8___yJuNc {
  margin-left: 8px !important;
}

.DateSeparator-module__m-l-10___dlFVy {
  margin-left: 10px !important;
}

.DateSeparator-module__m-l-16___Wuzbe {
  margin-left: 16px !important;
}

.DateSeparator-module__m-l-20___UrEBX {
  margin-left: 20px !important;
}

.DateSeparator-module__m-l-24___FfI1R {
  margin-left: 24px !important;
}

.DateSeparator-module__m-l-30___QZRoY {
  margin-left: 30px !important;
}

.DateSeparator-module__m-l-35____9vRE {
  margin-left: 35px !important;
}

.DateSeparator-module__m-l-40___juIvX {
  margin-left: 40px !important;
}

.DateSeparator-module__m-r-8___lsRUF {
  margin-right: 8px !important;
}

.DateSeparator-module__m-r-10___lkKaL {
  margin-right: 10px !important;
}

.DateSeparator-module__m-r-16___tOAEv {
  margin-right: 16px !important;
}

.DateSeparator-module__m-r-20___CpgCB {
  margin-right: 20px !important;
}

.DateSeparator-module__m-r-24___RUlJZ {
  margin-right: 24px !important;
}

.DateSeparator-module__m-r-30___ZaMnI {
  margin-right: 30px !important;
}

.DateSeparator-module__m-r-40___RPgS8 {
  margin-right: 40px !important;
}

.DateSeparator-module__border-r-3___ePeGq {
  border-radius: 3px !important;
}

.DateSeparator-module__border-r-4___u8DnF {
  border-radius: 4px !important;
}

.DateSeparator-module__border-r-6___L3BTK {
  border-radius: 6px !important;
}

.DateSeparator-module__border-r-10___HxceK {
  border-radius: 10px !important;
}

.DateSeparator-module__border-r-12___rl28G {
  border-radius: 12px !important;
}

.DateSeparator-module__border-r-16___iQXPs {
  border-radius: 16px !important;
}

.DateSeparator-module__border-r-50___shtQn {
  border-radius: 50% !important;
}

.DateSeparator-module__primary-border___NTNzV {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.DateSeparator-module__primary-border-b___J7IX9 {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.DateSeparator-module__primary-border-t___pWZiH {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.DateSeparator-module__primary-border-l___X9tqo {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.DateSeparator-module__primary-border-r___rmk5n {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.DateSeparator-module__secondary-border___gHPIi {
  border: 1px solid #637768;
}

.DateSeparator-module__secondary-border-b___WpQii {
  border-bottom: 1px solid #637768;
}

.DateSeparator-module__secondary-border-t___hIADI {
  border-top: 1px solid #637768;
}

.DateSeparator-module__secondary-border-l___e4VtA {
  border-left: 1px solid #637768;
}

.DateSeparator-module__secondary-border-r___Ow4vc {
  border-right: 1px solid #637768;
}

.DateSeparator-module__gap-0___onn84 {
  gap: 0 !important;
}

.DateSeparator-module__gap-2___zB8vR {
  gap: 2px !important;
}

.DateSeparator-module__gap-4___XEajJ {
  gap: 4px !important;
}

.DateSeparator-module__gap-5___PBsKF {
  gap: 5px !important;
}

.DateSeparator-module__gap-6___ad1CY {
  gap: 6px !important;
}

.DateSeparator-module__gap-8___eU4oa {
  gap: 8px !important;
}

.DateSeparator-module__gap-10___xqT8t {
  gap: 10px !important;
}

.DateSeparator-module__gap-12___y4lSS {
  gap: 12px !important;
}

.DateSeparator-module__gap-14___WpSKi {
  gap: 14px !important;
}

.DateSeparator-module__gap-16___KLt9l {
  gap: 16px !important;
}

.DateSeparator-module__gap-18___tD7RP {
  gap: 18px !important;
}

.DateSeparator-module__gap-20___vzfcA {
  gap: 20px !important;
}

.DateSeparator-module__gap-24___HAXSB {
  gap: 24px !important;
}

.DateSeparator-module__gap-26___pxgI4 {
  gap: 26px !important;
}

.DateSeparator-module__gap-30___B9vIj {
  gap: 30px !important;
}

.DateSeparator-module__gap-32___MX7mW {
  gap: 32px !important;
}

.DateSeparator-module__gap-40___fsh_x {
  gap: 40px !important;
}

.DateSeparator-module__gap-50___vr4PH {
  gap: 50px !important;
}

.DateSeparator-module__flex-1___uBsCV {
  flex: 1;
}

.DateSeparator-module__flex-none___XBy0o {
  flex: none !important;
}

.DateSeparator-module__flex-column___LF0Kg {
  display: flex;
  flex-direction: column !important;
}

.DateSeparator-module__flex-row___ji4yb {
  display: flex;
  flex-direction: row !important;
}

.DateSeparator-module__vertically-centered___nOJca {
  display: flex;
  align-items: center !important;
}

.DateSeparator-module__horizontally-centered___BzGGp {
  display: flex;
  justify-content: center !important;
}

.DateSeparator-module__horizontally-end___oQs8J {
  display: flex;
  justify-content: end !important;
}

.DateSeparator-module__vertically-start___LrCMT {
  display: flex;
  align-items: start !important;
}

.DateSeparator-module__space-between___I8ev9 {
  display: flex;
  justify-content: space-between !important;
}

.DateSeparator-module__flex-wrap___mX5xq {
  flex-wrap: wrap !important;
}

.DateSeparator-module__height-100___G6kLC {
  height: 100%;
}

.DateSeparator-module__width-50___ApNcd {
  width: 50% !important;
}

.DateSeparator-module__width-100___aB1Ip {
  width: 100%;
}

.DateSeparator-module__cursor-pointer___aKOnw {
  cursor: pointer;
}

.DateSeparator-module__cursor-not-allowed___MEXut {
  cursor: not-allowed !important;
}

.DateSeparator-module__absolute-centered___gGkml {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.DateSeparator-module__absolute___Y2c9V {
  position: absolute;
}

.DateSeparator-module__relative___Yz1bK {
  position: relative;
}

.DateSeparator-module__fixed___Oi1H7 {
  position: fixed;
}

.DateSeparator-module__visible___Y047t {
  opacity: 1;
}

.DateSeparator-module__invisible___lkFoY {
  opacity: 0;
}

.DateSeparator-module__col-90___Qnfsg {
  width: 90% !important;
}

.DateSeparator-module__col-auto___ZyNoi {
  width: auto !important;
}

.DateSeparator-module__medical-tabs___TGuJa {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.DateSeparator-module__medical-table-new___reg4C {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.DateSeparator-module__medical-table-new___reg4C:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.DateSeparator-module__medical-table-new___reg4C::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.DateSeparator-module__medical-table-new___reg4C::-webkit-scrollbar-track {
  display: none;
}
.DateSeparator-module__medical-table-new___reg4C.DateSeparator-module__no-pagination___JFL62 {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.DateSeparator-module__medical-table-new___reg4C.DateSeparator-module__no-pagination___JFL62:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.DateSeparator-module__medical-table-new___reg4C.DateSeparator-module__no-pagination___JFL62::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.DateSeparator-module__medical-table-new___reg4C.DateSeparator-module__no-pagination___JFL62::-webkit-scrollbar-track {
  display: none;
}

.DateSeparator-module__medical-table-empty___OCNeh {
  padding: 14px 40px !important;
}

.DateSeparator-module__icon-btn___oVbL9 {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.DateSeparator-module__search-icon___PtMQv {
  width: 24px;
  height: 24px;
  align-self: center;
}

.DateSeparator-module__disable-select___Yr86B {
  user-select: none;
}

.DateSeparator-module__break-word___TiF7E {
  word-break: break-word;
}

.DateSeparator-module__popup-clear-btn___xKkMO {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.DateSeparator-module__scroll-m-b-20___xsHdY {
  scroll-margin-bottom: 20px;
}

.DateSeparator-module__container___NCbkD {
  color: #637768;
}
.DateSeparator-module__container___NCbkD .DateSeparator-module__line___Ekspg {
  flex: 1;
  border-bottom: 1px solid #637768;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/components/elements/DateSeparator/DateSeparator.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,cAAA;AA8pBF;AA5pBE;EACE,OAAA;EACA,gCAAA;AA8pBJ","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.container {\n  color: get-color(greenNew, medium-dark);\n\n  .line {\n    flex: 1;\n    border-bottom: 1px solid get-color(greenNew, medium-dark);\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `DateSeparator-module__font-s-10___jWAo3`,
	"fontS12": `DateSeparator-module__font-s-12___lCdrE`,
	"fontS13": `DateSeparator-module__font-s-13___MuLNn`,
	"fontS14": `DateSeparator-module__font-s-14___dr2dM`,
	"fontS15": `DateSeparator-module__font-s-15___O8Sm4`,
	"fontS16": `DateSeparator-module__font-s-16___RU1wm`,
	"fontS18": `DateSeparator-module__font-s-18___epV4k`,
	"fontS20": `DateSeparator-module__font-s-20___fWkqF`,
	"fontS22": `DateSeparator-module__font-s-22___bKHWX`,
	"fontS28": `DateSeparator-module__font-s-28___ykbmv`,
	"fontW400": `DateSeparator-module__font-w-400___hFXGw`,
	"fontW500": `DateSeparator-module__font-w-500___MfeYF`,
	"fontW600": `DateSeparator-module__font-w-600___Tf2Xu`,
	"fontW700": `DateSeparator-module__font-w-700___dW177`,
	"p5": `DateSeparator-module__p-5___FyScb`,
	"p12": `DateSeparator-module__p-12___OffKn`,
	"p16": `DateSeparator-module__p-16___scc8V`,
	"p30": `DateSeparator-module__p-30___OXu_e`,
	"pB0": `DateSeparator-module__p-b-0___C7Nte`,
	"pB5": `DateSeparator-module__p-b-5___uyiyp`,
	"pB10": `DateSeparator-module__p-b-10___N8gBA`,
	"pB12": `DateSeparator-module__p-b-12___by46z`,
	"pB16": `DateSeparator-module__p-b-16___aUem7`,
	"pB18": `DateSeparator-module__p-b-18___GAyCG`,
	"pB20": `DateSeparator-module__p-b-20___mWwHW`,
	"pB25": `DateSeparator-module__p-b-25___cALw4`,
	"pB30": `DateSeparator-module__p-b-30___oFHtp`,
	"pB50": `DateSeparator-module__p-b-50___AQpI7`,
	"pT0": `DateSeparator-module__p-t-0___Mpjzg`,
	"pT12": `DateSeparator-module__p-t-12___P8OPG`,
	"pT16": `DateSeparator-module__p-t-16___cjhlo`,
	"pT18": `DateSeparator-module__p-t-18___zKaih`,
	"pT20": `DateSeparator-module__p-t-20___TqUTl`,
	"pT30": `DateSeparator-module__p-t-30___CLLif`,
	"pT40": `DateSeparator-module__p-t-40___W5oTO`,
	"pT50": `DateSeparator-module__p-t-50___YiB0Z`,
	"pL20": `DateSeparator-module__p-l-20___TRk5g`,
	"pL30": `DateSeparator-module__p-l-30___RBcHb`,
	"pL40": `DateSeparator-module__p-l-40___V4APa`,
	"pR16": `DateSeparator-module__p-r-16___eV432`,
	"pR20": `DateSeparator-module__p-r-20___kPvGz`,
	"pR30": `DateSeparator-module__p-r-30___bpEav`,
	"pR50": `DateSeparator-module__p-r-50___ypuCP`,
	"pR60": `DateSeparator-module__p-r-60___PgBHd`,
	"mB1": `DateSeparator-module__m-b-1___YtedF`,
	"mB2": `DateSeparator-module__m-b-2___sB4A_`,
	"mB6": `DateSeparator-module__m-b-6___tlDQQ`,
	"mB8": `DateSeparator-module__m-b-8___qfDkT`,
	"mB10": `DateSeparator-module__m-b-10___ahbc3`,
	"mB14": `DateSeparator-module__m-b-14___IN8np`,
	"mB16": `DateSeparator-module__m-b-16___VsS59`,
	"mB20": `DateSeparator-module__m-b-20___pjBW1`,
	"mB22": `DateSeparator-module__m-b-22___WpMtr`,
	"mB24": `DateSeparator-module__m-b-24___C4fPV`,
	"mB30": `DateSeparator-module__m-b-30___W0ynW`,
	"mB32": `DateSeparator-module__m-b-32___bGOzj`,
	"mB40": `DateSeparator-module__m-b-40___Y7UDe`,
	"mT2": `DateSeparator-module__m-t-2___CbfGq`,
	"mT3": `DateSeparator-module__m-t-3___NYQ5Q`,
	"mT4": `DateSeparator-module__m-t-4___thxhY`,
	"mT5": `DateSeparator-module__m-t-5___Y82ye`,
	"mT8": `DateSeparator-module__m-t-8___mWEyQ`,
	"mT10": `DateSeparator-module__m-t-10___cJHgv`,
	"mT15": `DateSeparator-module__m-t-15___EH5u2`,
	"mT16": `DateSeparator-module__m-t-16___lwMzS`,
	"mT20": `DateSeparator-module__m-t-20___IytLk`,
	"mT22": `DateSeparator-module__m-t-22___CIuOP`,
	"mT30": `DateSeparator-module__m-t-30___zilZY`,
	"mT32": `DateSeparator-module__m-t-32___e18aR`,
	"mLAuto": `DateSeparator-module__m-l-auto___dQ1wc`,
	"mL4": `DateSeparator-module__m-l-4___OcKPy`,
	"mL5": `DateSeparator-module__m-l-5___GGj7E`,
	"mL6": `DateSeparator-module__m-l-6___SpYzq`,
	"mL8": `DateSeparator-module__m-l-8___yJuNc`,
	"mL10": `DateSeparator-module__m-l-10___dlFVy`,
	"mL16": `DateSeparator-module__m-l-16___Wuzbe`,
	"mL20": `DateSeparator-module__m-l-20___UrEBX`,
	"mL24": `DateSeparator-module__m-l-24___FfI1R`,
	"mL30": `DateSeparator-module__m-l-30___QZRoY`,
	"mL35": `DateSeparator-module__m-l-35____9vRE`,
	"mL40": `DateSeparator-module__m-l-40___juIvX`,
	"mR8": `DateSeparator-module__m-r-8___lsRUF`,
	"mR10": `DateSeparator-module__m-r-10___lkKaL`,
	"mR16": `DateSeparator-module__m-r-16___tOAEv`,
	"mR20": `DateSeparator-module__m-r-20___CpgCB`,
	"mR24": `DateSeparator-module__m-r-24___RUlJZ`,
	"mR30": `DateSeparator-module__m-r-30___ZaMnI`,
	"mR40": `DateSeparator-module__m-r-40___RPgS8`,
	"borderR3": `DateSeparator-module__border-r-3___ePeGq`,
	"borderR4": `DateSeparator-module__border-r-4___u8DnF`,
	"borderR6": `DateSeparator-module__border-r-6___L3BTK`,
	"borderR10": `DateSeparator-module__border-r-10___HxceK`,
	"borderR12": `DateSeparator-module__border-r-12___rl28G`,
	"borderR16": `DateSeparator-module__border-r-16___iQXPs`,
	"borderR50": `DateSeparator-module__border-r-50___shtQn`,
	"primaryBorder": `DateSeparator-module__primary-border___NTNzV`,
	"primaryBorderB": `DateSeparator-module__primary-border-b___J7IX9`,
	"primaryBorderT": `DateSeparator-module__primary-border-t___pWZiH`,
	"primaryBorderL": `DateSeparator-module__primary-border-l___X9tqo`,
	"primaryBorderR": `DateSeparator-module__primary-border-r___rmk5n`,
	"secondaryBorder": `DateSeparator-module__secondary-border___gHPIi`,
	"secondaryBorderB": `DateSeparator-module__secondary-border-b___WpQii`,
	"secondaryBorderT": `DateSeparator-module__secondary-border-t___hIADI`,
	"secondaryBorderL": `DateSeparator-module__secondary-border-l___e4VtA`,
	"secondaryBorderR": `DateSeparator-module__secondary-border-r___Ow4vc`,
	"gap0": `DateSeparator-module__gap-0___onn84`,
	"gap2": `DateSeparator-module__gap-2___zB8vR`,
	"gap4": `DateSeparator-module__gap-4___XEajJ`,
	"gap5": `DateSeparator-module__gap-5___PBsKF`,
	"gap6": `DateSeparator-module__gap-6___ad1CY`,
	"gap8": `DateSeparator-module__gap-8___eU4oa`,
	"gap10": `DateSeparator-module__gap-10___xqT8t`,
	"gap12": `DateSeparator-module__gap-12___y4lSS`,
	"gap14": `DateSeparator-module__gap-14___WpSKi`,
	"gap16": `DateSeparator-module__gap-16___KLt9l`,
	"gap18": `DateSeparator-module__gap-18___tD7RP`,
	"gap20": `DateSeparator-module__gap-20___vzfcA`,
	"gap24": `DateSeparator-module__gap-24___HAXSB`,
	"gap26": `DateSeparator-module__gap-26___pxgI4`,
	"gap30": `DateSeparator-module__gap-30___B9vIj`,
	"gap32": `DateSeparator-module__gap-32___MX7mW`,
	"gap40": `DateSeparator-module__gap-40___fsh_x`,
	"gap50": `DateSeparator-module__gap-50___vr4PH`,
	"flex1": `DateSeparator-module__flex-1___uBsCV`,
	"flexNone": `DateSeparator-module__flex-none___XBy0o`,
	"flexColumn": `DateSeparator-module__flex-column___LF0Kg`,
	"flexRow": `DateSeparator-module__flex-row___ji4yb`,
	"verticallyCentered": `DateSeparator-module__vertically-centered___nOJca`,
	"horizontallyCentered": `DateSeparator-module__horizontally-centered___BzGGp`,
	"horizontallyEnd": `DateSeparator-module__horizontally-end___oQs8J`,
	"verticallyStart": `DateSeparator-module__vertically-start___LrCMT`,
	"spaceBetween": `DateSeparator-module__space-between___I8ev9`,
	"flexWrap": `DateSeparator-module__flex-wrap___mX5xq`,
	"height100": `DateSeparator-module__height-100___G6kLC`,
	"width50": `DateSeparator-module__width-50___ApNcd`,
	"width100": `DateSeparator-module__width-100___aB1Ip`,
	"cursorPointer": `DateSeparator-module__cursor-pointer___aKOnw`,
	"cursorNotAllowed": `DateSeparator-module__cursor-not-allowed___MEXut`,
	"absoluteCentered": `DateSeparator-module__absolute-centered___gGkml`,
	"absolute": `DateSeparator-module__absolute___Y2c9V`,
	"relative": `DateSeparator-module__relative___Yz1bK`,
	"fixed": `DateSeparator-module__fixed___Oi1H7`,
	"visible": `DateSeparator-module__visible___Y047t`,
	"invisible": `DateSeparator-module__invisible___lkFoY`,
	"col90": `DateSeparator-module__col-90___Qnfsg`,
	"colAuto": `DateSeparator-module__col-auto___ZyNoi`,
	"medicalTabs": `DateSeparator-module__medical-tabs___TGuJa`,
	"medicalTableNew": `DateSeparator-module__medical-table-new___reg4C`,
	"noPagination": `DateSeparator-module__no-pagination___JFL62`,
	"medicalTableEmpty": `DateSeparator-module__medical-table-empty___OCNeh`,
	"iconBtn": `DateSeparator-module__icon-btn___oVbL9`,
	"searchIcon": `DateSeparator-module__search-icon___PtMQv`,
	"disableSelect": `DateSeparator-module__disable-select___Yr86B`,
	"breakWord": `DateSeparator-module__break-word___TiF7E`,
	"popupClearBtn": `DateSeparator-module__popup-clear-btn___xKkMO`,
	"scrollMB20": `DateSeparator-module__scroll-m-b-20___xsHdY`,
	"container": `DateSeparator-module__container___NCbkD`,
	"line": `DateSeparator-module__line___Ekspg`
};
module.exports = ___CSS_LOADER_EXPORT___;
